import { commonErrors } from '@utils/error';
import { requiredCheckbox } from '@utils/validation';
import { z } from 'zod';
import { IMedicaidAttestationStepPageContent } from './MedicaidAttestationStep.component';

export const testContent: IMedicaidAttestationStepPageContent = {
	pageHeader:
		'At this time, we are unable to accept Medicaid, meaning we cannot offer clinical services to members enrolled in Medicaid.',
	pageInfo:
		'Please confirm that you are not enrolled in Medicaid Part B or a Medicaid Advantage plan to continue booking an appointment.',
	medicaidAttestationText:
		'I confirm that I am not enrolled in Medicaid Part B or a Medicaid Advantage plan. I understand the importance of providing accurate information and hereby attest to the truthfulness of my statement. I am aware of the serious implications of Medicaid fraud and agree to uphold the integrity of my declaration.',
};

export const schema = z.object({
	medicaidAttestation: requiredCheckbox(commonErrors.checkRequired),
});
